import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type LanguageCode = 'en' | 'it';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private static readonly STORAGE_KEY = 'uv.language';
  private static readonly PARAM: Record<LanguageCode, string> = {
    en: '?language=en',
    it: '?language=it'
  };

  private readonly translate = inject(TranslateService);

  public readonly available: LanguageCode[] = ['en', 'it'];

  public init(): void {
    this.translate.setDefaultLang(LanguageService.PARAM.en);
    this.translate.addLangs(Object.values(LanguageService.PARAM));
    this.use(this.preferredLanguage());
  }

  public get current(): LanguageCode {
    return this.translate.currentLang === LanguageService.PARAM.it ? 'it' : 'en';
  }

  public use(language: LanguageCode): void {
    this.translate.use(LanguageService.PARAM[language]);
    localStorage.setItem(LanguageService.STORAGE_KEY, language);
  }

  public preferredLanguage(): LanguageCode {
    const stored = localStorage.getItem(LanguageService.STORAGE_KEY) as LanguageCode | null;
    if (stored && this.available.includes(stored)) {
      return stored;
    }

    const browser = navigator.language?.slice(0, 2).toLowerCase() as LanguageCode;
    return this.available.includes(browser) ? browser : 'en';
  }
}
